mtl.alloy.factory['image-toggle'] = (function($) {
    'use strict';

    return function(element, options) {

        var $anchor = $(element);
        
        app.breakpoint.when('tablet-l desktop', function() {

                var thumbSrc = $anchor.attr('data-thumb-src');
                var image = '<img src="' + thumbSrc + '">';
                $anchor.append(image);

        }, function() {

            $anchor.empty();

        });

    };

}(jQuery));
